import { createStore, createEffect, createEvent, combine } from 'effector';
import { ApiUtils } from '@shared/utils';
import { AccountsApi, RequestStrategyEnum, type DocumentsResponse, type WithSignal } from '@shared/api';

const getDocumentsEffect = createEffect(({ signal, ...request }: WithSignal<{ id: number }>) => AccountsApi.getDocuments(request.id, signal));
const clearEvent = createEvent();

const $dataStore = createStore<DocumentsResponse[]>([])
  .on(getDocumentsEffect.done, (_, data) => data.result.data || [])
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(getDocumentsEffect.pending, (_, data) => data)
  .on(getDocumentsEffect.fail, (_, data) => ApiUtils.abortApiLoadingFailCaseTrigger(data.error))
  .on(getDocumentsEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getDocumentsEffect, () => null)
  .on(getDocumentsEffect.fail, (_, data) =>
    ApiUtils.abortApiErrorFailCaseTrigger(data.error, 'Something went wrong while fetching Documents. Please try again.'),
  )
  .on(getDocumentsEffect.done, () => null)
  .reset(clearEvent);

const getDocumentsApi = ApiUtils.wrapperApi(getDocumentsEffect, RequestStrategyEnum.Abort);
clearEvent.watch(() => getDocumentsApi.cancel());

export const $documentsStore = {
  events: {
    getDocuments: getDocumentsApi.trigger,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
